import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

const { common, spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	tabRoot: {
		paddingLeft: spacing.md,
	},
	tabs: {
		boxSizing: 'border-box',
		display: `flex`,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-around',
		height: 60,
		borderBottom: 'none',
	},
	tabTrigger: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: spacing.md,
		textDecoration: 'none',
		fontSize: `0.875rem`,
		color: colors.text.light,
		fontWeight: 500,
		height: 40,
		flexGrow: 1,
		borderBottom: common.border,
		':is([data-state="active"])': {
			color: colors.primary.main,
			borderBottom: `3px solid ${brandPrimary}`,
			...CssSelectors.allDescendants({
				fill: colors.primary.main,
				stroke: colors.primary.main,
			}),
		},
	},
	contactActivity: {
		height: `100%`,
	},
	contactActivityTabviewTabbarItemIcon: {
		display: 'inline-block',

		'@container contactActivity (min-width: 400px)': {
			display: 'none',
		},

		'@container contactActivity (min-width: 600px)': {
			display: 'inline-block',
		},
	},
	contactActivityTabviewTabbarItemTitle: {
		display: 'none',
		textAlign: 'center',

		'@container contactActivity (min-width: 400px)': {
			display: 'inline-block',
		},
	},
	dropdown: {
		width: 250,
	},
	richContentFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		margin: '0 30 0 auto',
		padding: '15px 0',
		zIndex: 1,
		...CssSelectors.allChildren({
			borderRadius: 30,
		}),
	},
	timelineFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingTop: 15,
		gap: spacing.md,
		alignItems: 'center',
	},
	expandToggleLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		cursor: 'pointer',
		userSelect: 'none',
	},
	expandToggleCheckbox: {
		accentColor: colors.primary.main,
		cursor: 'pointer',
	},
});
